/* HNM collection page (hnm-collection-* sections): quote carousel + Quick add variant picker.
   Add to cart itself is the theme's Nym Cart Drawer: our Quick add forms post to /cart/add, and the
   drawer's own submit handler adds the item, runs its tracking hooks and opens the drawer. */
(function () {
  function initRails(root) {
    (root || document).querySelectorAll('[data-hnmc-rail]').forEach(function (sec) {
      if (sec.dataset.hnmcReady) return; sec.dataset.hnmcReady = '1';
      var rail = sec.querySelector('.hnmc-quotes__rail'); if (!rail) return;
      var dots = sec.querySelectorAll('.hnmc-dot');
      function idx() { return Math.round(rail.scrollLeft / Math.max(1, rail.clientWidth)); }
      function go(i) { var n = rail.children.length; if (!n) return; i = (i + n) % n; rail.scrollTo({ left: i * rail.clientWidth, behavior: 'smooth' }); }
      sec.querySelectorAll('[data-dir]').forEach(function (b) { b.addEventListener('click', function () { go(idx() + Number(b.dataset.dir)); }); });
      dots.forEach(function (d, i) { d.addEventListener('click', function () { go(i); }); });
      rail.addEventListener('scroll', function () { var i = idx(); dots.forEach(function (d, j) { d.classList.toggle('is-active', i === j); }); }, { passive: true });
    });
  }
  document.addEventListener('click', function (e) {
    var open = e.target.closest('[data-hnmc-pick-open]');
    if (open) {
      e.preventDefault();
      document.querySelectorAll('.hnmc-card.is-picking').forEach(function (c) { c.classList.remove('is-picking'); });
      var card = open.closest('.hnmc-card'); card.classList.add('is-picking');
      var first = card.querySelector('.hnmc-pick input:checked') || card.querySelector('.hnmc-pick input:not(:disabled)');
      if (first) first.focus({ preventScroll: true });
      return;
    }
    var close = e.target.closest('[data-hnmc-pick-close]');
    if (close) { e.preventDefault(); close.closest('.hnmc-card').classList.remove('is-picking'); return; }
    if (!e.target.closest('.hnmc-pick')) document.querySelectorAll('.hnmc-card.is-picking').forEach(function (c) { c.classList.remove('is-picking'); });
  });
  document.addEventListener('submit', function (e) {
    var card = e.target.closest && e.target.closest('.hnmc-card');
    if (card) setTimeout(function () { card.classList.remove('is-picking'); }, 400);
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') document.querySelectorAll('.hnmc-card.is-picking').forEach(function (c) { c.classList.remove('is-picking'); });
  });
  // Hover image (mouse screens only). The second <img> has no src in the HTML, so nothing is fetched on load
  // or on phones. After the page has loaded, cards on screen get it (IntersectionObserver); hovering or
  // focusing a card gets it at once. The fade itself is CSS (opacity .2s).
  var hoverMQ = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)');
  var hoverIO = null;
  function loadHover(card) {
    var im = card && card.querySelector('img.hnmc-card__img2[data-src]'); if (!im) return;
    im.sizes = im.getAttribute('sizes') || '33vw';
    im.srcset = im.dataset.srcset || ''; im.src = im.dataset.src;
    im.removeAttribute('data-src'); im.removeAttribute('data-srcset');
    if (hoverIO) hoverIO.unobserve(card);
  }
  function initHover(root) {
    if (!hoverMQ || !hoverMQ.matches) return;
    var cards = (root || document).querySelectorAll('.hnmc-card--swap');
    cards.forEach(function (card) {
      if (card.dataset.hnmcHover) return; card.dataset.hnmcHover = '1';
      card.addEventListener('pointerenter', function () { loadHover(card); });
      card.addEventListener('focusin', function () { loadHover(card); });
    });
    function observe() {
      if (!('IntersectionObserver' in window)) return;
      if (!hoverIO) hoverIO = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) loadHover(e.target); }); }, { rootMargin: '0px 0px 200px 0px' });
      cards.forEach(function (card) { if (card.querySelector('img.hnmc-card__img2[data-src]')) hoverIO.observe(card); });
    }
    if (document.readyState === 'complete') observe(); else window.addEventListener('load', observe, { once: true });
  }
  function showActiveChip(root) {
    (root || document).querySelectorAll('.hnmc-chips').forEach(function (row) {
      var a = row.querySelector('.hnmc-chip.is-active');
      if (!a || row.scrollWidth <= row.clientWidth) return;
      row.scrollLeft = Math.max(0, a.offsetLeft - row.offsetLeft - (row.clientWidth - a.offsetWidth) / 2);
    });
  }
  function initAll(root) { initRails(root); showActiveChip(root); initHover(root); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); }); else initAll();
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
